import { useDependencies } from "../useDependencies";
import { useAuth } from "../useAuth";
import { useDocumentationArea } from "../useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";
import { useDocumentationAreaMutation } from "../useDocumentationAreaMutation";

interface MutationFnProps {
  identityVerificationId: string;
  country: string;
}

export const useSelectIdentityVerificationCountry = () => {
  const { token } = useAuth();
  const { documentationArea } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  if (!documentationArea) throw new DocumentationAreaNotFoundError();

  const mutationFn = async ({ identityVerificationId, country }: MutationFnProps) => {
    return await documentationAreaController.patchActorIDVOrder({
      accessToken: token,
      documentationAreaId: documentationArea.getId(),
      actorId: documentationArea.getActor().getId(),
      orderId: identityVerificationId,
      issuingCountry: country,
    });
  };

  const { mutate, isSuccess } = useDocumentationAreaMutation({
    mutationFn,
  });

  return {
    mutate,
    isSuccess,
  };
};
